import React, { useState } from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import '../../../../assets/css/user/home/subscreens/testimonials/Testimonials.css';
import testimonial1Img from '../../../../assets/images/home/testimonial1.jpg';
import testimonial2Img from '../../../../assets/images/home/testimonial2.jpg';
import testimonial3Img from '../../../../assets/images/home/testimonial3.jpg';

const Testimonials= () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const testimonials = [
    {
      id: 1,
      image: testimonial1Img,
      title: 'Customer Satisfaction',
      description: 'The equipment rental service made our farming work much easier during peak season. Machines were delivered on time and worked perfectly in the field. It helped us complete our work faster without any delays.',
      name: 'Muhammad Aslam'
    },
    {
      id: 2,
      image: testimonial2Img,
      title: 'Excellent Service',
      description: 'Their maintenance service is very reliable and quick. Whenever our tractor had an issue, their team responded immediately and fixed it professionally. It saved us from major losses during important farming days.',
      name: 'Ali Raza'
    },
    {
      id: 3,
      image: testimonial3Img,
      title: 'Reliable Partner',
      description: 'We have been using their rental services regularly and the experience has always been smooth. The equipment is well-maintained and easy to book. It’s a trustworthy platform for every farmer.',
      name: 'Ahmed Hassan'
    }
  ];

  return (
    <section className="testimonial-carousel-section">
      <Container>
        <Carousel 
          activeIndex={index} 
          onSelect={handleSelect}
          indicators={false}
          controls={false}
          interval={3000}
        >
          {testimonials.map((testimonial) => (
            <Carousel.Item key={testimonial.id}>
              <Row className="align-items-center testimonial-row">
                {/* Left Image Section */}
                <Col lg={5} md={12} className="image-col1">
                  <div className="image-wrapper">
                    <div className="orange-border-bg"></div>
                    <div className="testimonial-image-container">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="testimonial-image"
                      />
                    </div>
                  </div>
                </Col>

                {/* Right Content Section */}
                <Col lg={7} md={12} className="testimonial-content-col">
                
                  <div className="testimonial-content">
                    <h2 className="testimonial-title">{testimonial.title}</h2>
                    <p className="testimonial-description">{testimonial.description}</p>
                    <div className="testimonial-author">
                      <span className="author-line"></span>
                      <span className="author-name">{testimonial.name}</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Custom Navigation Dots */}
        <div className="custom-indicators">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              className={`indicator-dot ${idx === index ? 'active' : ''}`}
              onClick={() => setIndex(idx)}
              aria-label={`Go to testimonial ${idx + 1}`}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Testimonials;